export default "__VITE_ASSET__CBfvZSaJ__"